import { render, staticRenderFns } from "./OrderReceiverInformation.vue?vue&type=template&id=001dacb6&scoped=true"
import script from "./OrderReceiverInformation.vue?vue&type=script&lang=js"
export * from "./OrderReceiverInformation.vue?vue&type=script&lang=js"
import style0 from "./OrderReceiverInformation.vue?vue&type=style&index=0&id=001dacb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001dacb6",
  null
  
)

export default component.exports